import { MATERIAL, MODEL_ID, POLYCOUNT_MODE, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { buildImageInput } from './buildImageInput'

/**
 * Inverse of parseMeshyImageTo3dProData. Builds an openedModel-shaped payload
 * from the current modelSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseMeshyImageTo3dProData
 */
export const buildMeshyImageTo3dProFromState = (state, id) => {
  const { modelSettings } = state
  const {
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    isUnlimitedPolycount,
    isSmartLowPoly,
    extraQuality,
    selectedUseCase,
  } = modelSettings || {}

  return {
    id,
    providerKey: PROVIDER.MESHY,
    providerModelId: MODEL_ID.MESHY_IMAGE_TO_3D_PRO,
    enablePbr: material === MATERIAL.PBR,
    geometryOnly: material === MATERIAL.GEOMETRY_ONLY,
    private: isPrivate,
    useCase: selectedUseCase,
    ...buildImageInput(modelSettings),
    providerRunAttributes: {
      ...(targetPolycount != null && { target_polycount: targetPolycount }),
      ...(isUnlimitedPolycount && !isSmartLowPoly && { polycount_mode: POLYCOUNT_MODE.UNLIMITED }),
      ...(!isSmartLowPoly && polygonType != null && { topology: polygonType }),
      ...(isSmartLowPoly && { generate_type: 'LowPoly' }),
      ...(extraQuality && !isSmartLowPoly && { geometry_resolution: '2k' }),
    },
  }
}
